var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7862 2.75397V1.37361C11.7862 1.25397 11.6487 1.1879 11.5558 1.26111L3.5058 7.54862C3.43741 7.60181 3.38206 7.66992 3.34399 7.74775C3.30592 7.82558 3.28613 7.91108 3.28613 7.99772C3.28613 8.08437 3.30592 8.16987 3.34399 8.2477C3.38206 8.32553 3.43741 8.39364 3.5058 8.44683L11.5558 14.7343C11.6504 14.8075 11.7862 14.7415 11.7862 14.6218V13.2415C11.7862 13.154 11.7451 13.07 11.6772 13.0165L5.24866 7.99862L11.6772 2.97897C11.7451 2.9254 11.7862 2.84147 11.7862 2.75397Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.687e87ce93889796b01f442c2de14667.svg";
export { ForwardRef as ReactComponent };